import { getCookie } from 'cookies-next'
import { isAndroid, isIOS, isWebview } from '@gate/toolkit'
export type ShareNativeParams = {
  link: string //分享链接,需要手动拼接用户邀请码 示例：https://gate.io/rewards_hub?ch=RewardsHub&ref_uid=UFFEV1BAVFC
  text: string //分享的文本  示例: 下载Gate.io，与我同行，共享福利中心丰厚好礼！
  title?: string | null //分享弹窗标题，默认是  Share|分享
  source?: string //渠道来源，用于数据统计,该字段需要PD提供
  ratios?: string | string[] //图片比例列表，默认是 '3x4' ,支持多比例 ['3x4','1x1','9x16']
  ext?: Record<string, string> //额外信息，用于自定义海报内容
  themeType?: number //0:同时支持亮色和暗色  1:仅亮色  2:仅暗色
  channelPostHidden?: boolean
}

/* ====================== *
 *    工具方法
 * ====================== */
export function checkAppVersion(androidMin: number, iosMin: number) {
  const androidBuild = getCookie('android_build')
  const iosBuild = getCookie('ios_build')
  if (androidBuild) {
    return Number(androidBuild) >= androidMin
  }
  if (iosBuild) {
    return Number(iosBuild) >= iosMin
  }
  return false
}

function callNativeShareV3(p: Record<string, any>) {
  const d = {
    module: 'system',
    method: 'shareImageV3',
    params: JSON.stringify(p),
  }
  ;(window as any).gateioV2?.callNative(JSON.stringify(d))
}

/* ====================== *
 *    业务逻辑
 * ====================== */
//是否支持F1分享弹窗(v2版本)调用
export const appSupportF1Share = () => isWebview() && checkAppVersion(653000, 202503100001)

//打开app f1分享弹窗(v2版本)
export function openAppF1ShareModal({
  link,
  text,
  source = '',
  ext,
  title = null,
  ratios = '3x4',
  themeType = 0,
  channelPostHidden = true,
}: ShareNativeParams) {
  const shareTextWithUrl = `${text} ${link}`
  const ratioList = Array.isArray(ratios) ? ratios : [ratios]
  // 自定义海报内容提供默认值
  ext = ext || {
    from: 'ext_content_for_html',
    positioned_top: '100',
    positioned_bottom: '0',
    positioned_start: '20',
    positioned_end: '20',
    html: `
          <div><h2 style="color:#fff;width:200px;font-size: 22px">${text}</h2></div>
          `,
  }
  const shareParams = {
    config: {
      title, //分享弹窗标题
      source, //业务方来源,
      themeType, //0:同时支持亮色和暗色  1:亮色  2:暗色
      channelPostHidden,
    },
    items: ratioList.map(ratio => ({
      shareUrl: link,
      copyText: shareTextWithUrl,
      shareContent: shareTextWithUrl,
      contentAspectRatio: ratio,
      shareImageDefault: 'red_bull_f1',
      shareImageUrl: 'red_bull_f1',
      source,
      ext: ext,
      // 是否解析base64，不传base64图片则为false
      nativeParse: false,
    })),
  }
  callNativeShareV3(shareParams)
}

//打开app v1版本的分享弹窗
type V1ShareParams = {
  text: string //分享的文本
  link: string //分享链接,需要手动拼接用户邀请码 示例：https://gate.io/rewards_hub?ch=RewardsHub&ref_uid=UFFEV1BAVFC
  image?: string //分享的图片
  title?: string | null //分享弹窗标题,不传使用默认标题
}
export function openAppShareModalV1({ link, text, title = null }: V1ShareParams) {
  const shareTextWithUrl = `${text} ${link}`

  if (isAndroid()) {
    window?.gateio.shareNative(
      JSON.stringify({
        image: '',
        title,
        text: shareTextWithUrl,
      })
    )
  } else if (isIOS()) {
    window?.webkit.messageHandlers.shareUrl.postMessage(
      JSON.stringify({
        webTitle: shareTextWithUrl,
        webUrl: link,
      })
    )
  }
}

/**
 * 🍎🍎🍎打开app分享弹窗    app分享弹窗文档:https://gtglobal.jp.larksuite.com/wiki/Keq7waFePiIsn2kud37j2hUQped
 * 使用方式：
 import {  openAppShareModal } from '@gateio/core-lib'
 import { isWebview } from '@gate/toolkit'
 if(isWebview()){
 openAppShareModal({
 link: 'https://gate.io/rewards_hub?ch=RewardsHub&ref_uid=UFFEV1BAVFC',
 text:'下载Gate.io，与我同行，共享福利中心丰厚好礼！'
 })
 }
 */
export function openAppShareModal(params: ShareNativeParams) {
  if (appSupportF1Share()) {
    //打开f1分享弹窗
    openAppF1ShareModal(params)
  } else {
    //打开app v1版本的分享弹窗
    openAppShareModalV1(params)
  }
}
